import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {API_URLS} from 'src/environments/env-routes';
import { APIHelper } from 'src/shared/services/api-helper/api-helper.service';

@Component({
  selector: 'app-dialog-share-file',
  templateUrl: './dialog-share-file.component.html',
  styleUrls: ['./dialog-share-file.component.scss']
})
export class DialogShareFileComponent implements OnInit {
  public selectedId: string;
  public ariane;
  public loading: boolean;
  public file: any;
  public name: string;
  public sharedId: string;
  public sharedLink: string;
  @ViewChild('input') inputText;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogShareFileComponent>,
    private api: APIHelper
  ) {}

  ngOnInit() {
    this.loading = false;
    this.file = this.data.file;
    this.selectedId = this.data.file.id;

    this.name = this.file.name;

    if (this.file.properties['qshare:sharedId']) {
      this.sharedLink = this.formatUrl(this.file.properties['qshare:sharedId']);
    } else {
      this.getSharedId();
    }
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  public getSharedId() {
    const body = {
      nodeId: this.data.file.id
    };

    this.api
      .requestApi({
        action: API_URLS.sharedLink.link,
        method: 'POST',
        datas: body
      })
      .then(res => {
        this.sharedLink = this.formatUrl(res.id);
        this.file.properties['qshare:sharedId'] = res.id;
      });
  }

  formatUrl(sharedId) {
    return `${window.location.origin}/public/preview/${sharedId}`;
  }
  onCopy() {
    this.inputText.nativeElement.removeAttribute('disabled');
    this.inputText.nativeElement.select();
    this.inputText.nativeElement.setAttribute('disabled', 'disabled');
    document.execCommand('copy');
  }
}
